import { CallMethodEnums } from '@/types/api';
import {
  PromptCreateArgs,
  PromptCreateRes,
  PromptDeleteArgs,
  PromptDeleteRes,
  PromptGetArgs,
  PromptGetRes,
  PromptsGetArgs,
  PromptsGetRes
} from '@/types/prompts';

import { call } from './utils';

// TODO: [jh 2025-06-20] camel it and alias in middleware

const URL_PROMPT_BASE = '/api/prompt_management';

export const promptCreate = async( args: PromptCreateArgs ): Promise<PromptCreateRes> => {
  const json = await call<unknown, PromptCreateRes>( {
    isProtected: true,
    body: args.prompt,
    method: CallMethodEnums.POST,
    route: `${ URL_PROMPT_BASE }/prompt`
  } );

  return json;
};

export const promptDelete = async( args: PromptDeleteArgs ): Promise<PromptDeleteRes> => {
  const {
    name,
    tags,
    version
  } = args;

  const params = new URLSearchParams( {
    name
  } );

  if( tags !== null ) params.append( 'tags', tags );
  if( version !== null ) params.append( 'version', version.toString() );

  const json = await call<unknown, PromptDeleteRes>( {
    isProtected: true,
    method: CallMethodEnums.DELETE,
    route: `${ URL_PROMPT_BASE }/prompt?${ params.toString() }`
  } );

  return json || {};
};

export const promptGet = async( args: PromptGetArgs ): Promise<PromptGetRes> => {
  const {
    name,
    tags,
    version
  } = args;

  const params = new URLSearchParams( {
    name
  } );

  if( tags !== null ) params.append( 'tags', tags );
  if( version !== null ) params.append( 'version', version.toString() );

  const json = await call<unknown, PromptGetRes>( {
    isProtected: true,
    method: CallMethodEnums.GET,
    route: `${ URL_PROMPT_BASE }/prompt?${ params.toString() }`
  } );

  return json;
};

export const promptValidate = async( args: PromptCreateArgs ): Promise<PromptCreateRes> => {
  const json = await call<unknown, PromptCreateRes>( {
    isProtected: true,
    body: args.prompt,
    method: CallMethodEnums.POST,
    route: `${ URL_PROMPT_BASE }/prompt/validate`
  } );

  return json;
};

export const promptsGet = async( args: PromptsGetArgs ): Promise<PromptsGetRes> => {
  const {
    name,
    only_latest,
    page,
    pageSize,
    tags
  } = args;

  const preParams: Record<string, string> = { name };

  if( only_latest !== undefined ) preParams.only_latest = only_latest.toString();
  if( page ) preParams.page = page.toString();
  if( pageSize ) preParams.pageSize = pageSize.toString();
  if( tags !== null ) preParams.tags = tags;

  const params = new URLSearchParams( preParams );

  const json = await call<unknown, PromptsGetRes>( {
    isProtected: true,
    method: CallMethodEnums.GET,
    route: `${ URL_PROMPT_BASE }/prompts?${ params.toString() }`
  } );

  return json;
};
